import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { NewsletterService } from '../../../core/services/newsletter.service';

@Component({
  selector: 'app-club-subscribe',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './club-subscribe.html',
  styleUrl: './club-subscribe.css',
})
export class ClubSubscribe {
  @Input() source = 'footer';
  @Input() variant: 'footer' | 'page' = 'footer';

  email = '';
  optIn = true;
  submitting = false;

  constructor(
    private newsletter: NewsletterService,
    private messageService: MessageService
  ) {}

  submit() {
    const trimmed = this.email.trim();
    if (!trimmed) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Correo requerido',
        detail: 'Ingresa tu correo para unirte al Club.',
      });
      return;
    }
    if (!this.isValidEmail(trimmed)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Correo inválido',
        detail: 'Revisa el formato de tu correo.',
      });
      return;
    }
    if (!this.optIn) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Confirmación requerida',
        detail: 'Marca la casilla para recibir novedades.',
      });
      return;
    }
    if (this.submitting) return;

    this.submitting = true;
    this.newsletter.subscribe({
      email: trimmed,
      optIn: true,
      source: this.source,
    }).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Club Moanani',
          detail: res.message,
        });
        this.email = '';
        this.optIn = true;
        this.submitting = false;
      },
      error: (err) => {
        const detail = err?.error?.message
          || err?.error?.detail
          || err?.error?.error
          || (err?.status === 429 ? 'Demasiados intentos. Espera un momento.' : 'No se pudo completar la suscripción.');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail,
        });
        this.submitting = false;
      }
    });
  }

  private isValidEmail(value: string): boolean {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
  }
}